import { FeatureFlagName } from "constants/featureFlags";
import { FeatureFlagsContext } from "contexts/FeatureFlagsContext";
import { useAuth } from "hooks/useAuth";
import { useContext, useMemo } from "react";
import {
    FeatureFlagUser,
    canViewFeature,
    canViewFeatureFromData
} from "utils/featureFlagsEvaluator";

export function useFeatureFlags() {
    const { me, isLoggedIn } = useAuth();
    const { flags, loading, error, isFromHasura, refetch } =
        useContext(FeatureFlagsContext);

    const featureFlagUser: FeatureFlagUser | null = useMemo(() => {
        if (!isLoggedIn || !me) {
            return null; // guest로 처리됨
        }

        return {
            id: me.id,
            role: "user" as const
        };
    }, [me, isLoggedIn]);

    const isFeatureEnabled = useMemo(
        () => (featureName: FeatureFlagName) => {
            const flagData = flags.get(featureName);

            // Debug logging for UI_HEADER_DROPDOWN
            // if (featureName === "UI_HEADER_DROPDOWN") {
            //     console.log("[useFeatureFlags] UI_HEADER_DROPDOWN debug:", {
            //         isFromHasura,
            //         flagData,
            //         flagsSize: flags.size,
            //         allFlagNames: Array.from(flags.keys())
            //     });
            // }

            // If we have Hasura data (even if this specific flag isn't in it), use Hasura's decision
            if (isFromHasura) {
                // Flag exists in Hasura - use Hasura's evaluation
                if (flagData) {
                    const result = canViewFeatureFromData(
                        flagData,
                        featureFlagUser
                    );
                    // if (featureName === "UI_HEADER_DROPDOWN") {
                    //     console.log(
                    //         "[useFeatureFlags] UI_HEADER_DROPDOWN from Hasura:",
                    //         result
                    //     );
                    // }
                    return result;
                }
                // Flag doesn't exist in Hasura - treat as disabled
                // This prevents falling back to static constants when Hasura is working
                if (featureName === "UI_HEADER_DROPDOWN") {
                    console.log(
                        "[useFeatureFlags] UI_HEADER_DROPDOWN not in Hasura, returning false"
                    );
                }
                return false;
            }

            // Hasura is disabled or unavailable - use static constants as fallback
            // This helps during build time or when Hasura is explicitly disabled
            const fallbackResult = canViewFeature(featureName, featureFlagUser);
            // if (featureName === "UI_HEADER_DROPDOWN") {
            //     console.log("[useFeatureFlags] UI_HEADER_DROPDOWN from fallback:", fallbackResult);
            // }
            return fallbackResult;
        },
        [flags, featureFlagUser, isFromHasura]
    );

    return {
        isFeatureEnabled,
        user: featureFlagUser,
        loading,
        error,
        isFromHasura,
        refetch
    };
}
